import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavParams, ToastController} from 'ionic-angular';

// import { AlertProvider } from '../../providers/alert/alert';
import {ProofServerProvider} from '../../providers/proof-server/proof-server';

/**
 * Generated class for the ProofFinishedDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-proof-finished-detail',
  templateUrl: 'proof-finished-detail.html',
})
export class ProofFinishedDetailPage {

  loading: boolean = false;
  proof: any = null;

  constructor(
    private navParams: NavParams,
    // private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private proofServerProvider: ProofServerProvider
  ) {
    this.loading = true;

    let loader = this.loadingCtrl.create({
      content: 'Obtendo detalhe do meu desempenho...',
    });
    loader.present();

    let that = this;
    this.proof = this.navParams.get('proof');

    this.proofServerProvider.fetchResponseFeedback(this.proof.id).subscribe(proof => {
      that.loading = false;
      loader.dismiss();

      try {
        if (that.proof !== null) {
          if (proof.createdAt) {
            proof.createdAt = new Date(proof.createdAt.replace(/\s+/g, 'T').concat('.000-03:00'));
          }

          if (proof.finishedAt) {
            proof.finishedAt = new Date(proof.finishedAt.replace(/\s+/g, 'T').concat('.000-03:00'));
          }

          if (proof.totalCorrectPercent) {
            proof.totalCorrectPercent = proof.totalCorrectPercent.toFixed(2).replace('.', ',');
          }

          if (proof.totalWrongPercent) {
            proof.totalWrongPercent = proof.totalWrongPercent.toFixed(2).replace('.', ',');
          }

          that.proof = proof;
        }
      } catch (ex) {
        that.doNotRetrivedProof(ex);
      }
    }, (error: any) => {
      that.loading = false;
      loader.dismiss();
      that.doNotRetrivedProof(error);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProofFinishedDetailPage');
  }

  private doNotRetrivedProof(error = null) {
    this.proof = null;

    console.log('Não foi possível obter detalhe do meu desempenho.', error);

    let toast = this.toastCtrl.create({
      message: 'Não foi possível obter detalhe do meu desempenho.',
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  getDetail(proof: any) {
    console.log(proof);
  }

}



// WEBPACK FOOTER //
// ./src/pages/proof-finished-detail/proof-finished-detail.ts